import React from "react";
import OrderForm from "./OrderForm";
import Xhr from "../../../../helpers/Xhr";
import {LOCAL} from "../../../../constants/local";

class ByMobile extends OrderForm {
	static defaultProps = {
		minAmount : 1,
		maxAmount : 50.00
	};

	state = {
		amount   : this.props.minAmount,
		toPay    : this.props.minAmount * 0.96,
		nalog    : this.props.minAmount * 0.04,
		phone    : '',
		provider : 100
	};

	onSubmit() {
		const data = {
			amount   : this.state.amount,
			phone    : this.state.phone,
			provider : this.state.provider
		};

		if ( this.state.amount > this.props.maxAmount ) {
			alert(`Максимальная сумма заказа - ${this.props.maxAmount} ${LOCAL.currency}!`);
			return;
		}

		if ( !this.hasErrors ) {
			Xhr.cashOutMobile(data).then((resp) => {
				this.setState({
					messages : resp.messages
				});
			});
		}
	}

	changeProvider(e) {
		this.setState({
			provider : parseInt(e.target.value)
		});
	}

	render() {
		return (
			<div className="description__order">
				{/*Сумма заказа*/}
				{this.getAmountRow()}

				{/*Сумма к выплате*/}
				{this.getToPayRow()}

				{/*Налог*/}
				{this.getNalogRow()}

				{/*Провайдер*/}
				{this.getProviderRow()}

				{/*Номер телефона*/}
				{this.getPhoneRow()}

				{this.getOrderButton()}

				{this.state.messages !== '' &&
				<div className="description__order-item">
					<div></div>
					<div className="errors">{this.state.messages}</div>
					<div></div>
				</div>}

				<div className="description__order-warning">
					<div className="description__order-warning-header">Внимание!</div>
					<div className="description__order-warning-text">Игрок несет ответственность за правильность указанных данных мобильного телефона (код оператора, номер телефона). Букмекер не несет никакой ответственности за ошибку Игрока, при неверно указанных данных номера мобильного телефона.</div>
				</div>
			</div>
		);
	}
}

export default ByMobile;


// WEBPACK FOOTER //
// ./src/app/pages/User/Takemoney/Form/ByMobile.js